export const settingsListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Category',
  },
  {
    name: 'rangeStart',
    label: 'Score',
  },
  {
    name: 'action',
    label: 'Scenario',
  },
  {
    name: 'createdAt',
    label: 'Date added',
  },
  {
    name: 'updatedAt',
    label: 'Date updated',
  },
];

export const settingsListDefaultSorter = {};

export const settingsListSchema = {};

export const settingsListFiltersSchema = [];
